module.exports = __webpack_public_path__ + "img/pros.7749bef1.jpg";